unit DonationsForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, BaseList, Data.DB, WEBLib.ExtCtrls, WEBLib.Actions, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, WEBLib.DBCtrls, Vcl.Controls, WEBLib.Lists, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.WebCtrls, smx.webcore.types, XData.Web.Client;

type
  TDonationsList = class(TBaseListForm)
    CaptionSpan: THTMLSpan;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetExternalId: TStringField;
    MainDatasetSponsored: TBooleanField;
    MainDatasetTransactionDate: TDateTimeField;
    MainDatasetImportId: TIntegerField;
    MainDatasetClaimId: TIntegerField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetDonorId: TIntegerField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetClaimDate: TDateTimeField;
    MainDatasetTaxYear: TIntegerField;
    MainDatasetClaimRef: TStringField;
    MainDatasetDonorPostCode: TStringField;
    MainDatasetDonorName: TStringField;
    MainDatasetErrorText: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetSourceType: TStringField;
    WebTimer1: TTimer;
    WebButton1: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure SearchButtonClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
  private
    FShowStatus: String;
    procedure SetShowCaption(const Value: String);
    //procedure SetGrid;
    { Private declarations }
  protected
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
    procedure LoadData; override;

    //function GetEditFormClass: TWebFormClass;
    function InitSortCol: Integer;override;
    function InitSortDirection: TSortDirection;override;
    function CreateGridInFormCreate: boolean;override;
    procedure SearchData(const Value: string);override;
    [async]
    procedure GenerateUnclaimedDonationsCSVFile; async;

  public
    { Public declarations }
    property ShowStatus: String read FShowStatus write FShowStatus;
    property ShowCaption: String write SetShowCaption;

  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  MainDataModule,
  Reports.Donation.Utils;


procedure TDonationsList.WebFormCreate(Sender: TObject);
begin
  inherited;
end;

{ TUnclaimedDonations }

procedure TDonationsList.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
begin
  inherited;

end;

procedure TDonationsList.LoadData;
begin
  CreateGridPlugin;
  FGridPlugin.SetPreparedFilter('ClaimStatus eq Unclaimed');
end;

procedure TDonationsList.PrepareForm;
begin
  FIdField := 'Id';
end;

procedure TDonationsList.SearchButtonClick(Sender: TObject);
begin
  SearchData(edSearch.Text);
end;

procedure TDonationsList.SetShowCaption(const Value: String);
begin
 CaptionSpan.HTML.Text := Value;
end;

procedure TDonationsList.WebFormShow(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TDonationsList.SearchData(const Value: string);
var
  lSearchStr: string;
  lQuery: string;
begin
  lSearchStr := Uppercase(edSearch.text);

  lQuery := Format(
    '(contains(upper(DonorName), ''%s'') OR contains(upper(DonorPostCode), ''%s'')) ' +
    'and (ClaimStatus eq ''Unclaimed'')', [lSearchStr, lSearchStr]);
  FGridPlugin.SetPreparedFilter(lQuery);
end;

function TDonationsList.InitSortCol: Integer;
begin
  Result := 1;
end;

function TDonationsList.InitSortDirection: TSortDirection;
begin
  Result := TSortDirection.sdDesc;
end;

function TDonationsList.CreateGridInFormCreate: boolean;
begin
  result := false;
end;

procedure TDonationsList.WebButton1Click(Sender: TObject);
begin
  GenerateUnclaimedDonationsCSVFile;
end;


procedure TDonationsList.GenerateUnclaimedDonationsCSVFile;
//var
begin
  Await(TDonationReportUtils.DonationReport('DN.CLAIM_STATUS', 'Unclaimed', 0, 0, '', '', TReportOutput.roCSV));
end;

(*
procedure TDonationsList.GenerateUnclaimedDonationsCSVFile;
var
  lRetval: TXDataClientResponse;
  lData: string;
  lFileName: string;
  lTimeStamp: string;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CreateUnclaimedDonationsCSVFile', []));
  lData  := JS.ToString(lRetval.ResultAsObject['value']);
  lTimeStamp := FormatDateTime('YYYYMMDDhhnnss', Now);
  lFileName := Format('GiftAider-UnclaimedDonations_%s.csv', [lTimeStamp]);

  Application.DownloadTextFile(lData, lFileName);
end;
*)

(*
procedure TDonationsList.SetGrid;
begin
//  DataTable.Columns[0].DataField := 'Id';
//  DataTable.Columns[0].Title := 'Donor Id';

  DataTable.Columns[1].DataField := '';
  DataTable.Columns[1].Title := 'Donor Name';

  DataTable.Columns.Delete(2);
end;
*)



procedure TDonationsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CaptionSpan := THTMLSpan.Create('CaptionSpan');
  WebButton1 := TButton.Create('UnclaimedDonations');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetSponsored := TBooleanField.Create(Self);
  MainDatasetTransactionDate := TDateTimeField.Create(Self);
  MainDatasetImportId := TIntegerField.Create(Self);
  MainDatasetClaimId := TIntegerField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetDonorId := TIntegerField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetClaimDate := TDateTimeField.Create(Self);
  MainDatasetTaxYear := TIntegerField.Create(Self);
  MainDatasetClaimRef := TStringField.Create(Self);
  MainDatasetDonorPostCode := TStringField.Create(Self);
  MainDatasetDonorName := TStringField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  WebTimer1 := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  CaptionSpan.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetSponsored.BeforeLoadDFMValues;
  MainDatasetTransactionDate.BeforeLoadDFMValues;
  MainDatasetImportId.BeforeLoadDFMValues;
  MainDatasetClaimId.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetDonorId.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetClaimDate.BeforeLoadDFMValues;
  MainDatasetTaxYear.BeforeLoadDFMValues;
  MainDatasetClaimRef.BeforeLoadDFMValues;
  MainDatasetDonorPostCode.BeforeLoadDFMValues;
  MainDatasetDonorName.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Top := 110;
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorName';
      Title := 'Donor';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorPostCode';
      Title := 'Post Code';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ClaimStatus';
      Title := 'ClaimStatus';
    end;
    CaptionSpan.SetParentComponent(Self);
    CaptionSpan.Name := 'CaptionSpan';
    CaptionSpan.Left := 632;
    CaptionSpan.Top := 48;
    CaptionSpan.Width := 100;
    CaptionSpan.Height := 40;
    CaptionSpan.HeightStyle := ssAuto;
    CaptionSpan.WidthStyle := ssAuto;
    CaptionSpan.ChildOrder := 10;
    CaptionSpan.ElementPosition := epIgnore;
    CaptionSpan.ElementFont := efCSS;
    CaptionSpan.Role := '';
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 207;
    WebButton1.Top := 439;
    WebButton1.Width := 297;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Download Unnclaimed Donations';
    WebButton1.ChildOrder := 9;
    WebButton1.ElementClassName := 'btn btn-secondary';
    WebButton1.ElementPosition := epIgnore;
    WebButton1.HeightStyle := ssAuto;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthStyle := ssAuto;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    MainDataset.EntitySetName := 'Donation';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 255;
    MainDatasetSponsored.SetParentComponent(MainDataset);
    MainDatasetSponsored.Name := 'MainDatasetSponsored';
    MainDatasetSponsored.FieldName := 'Sponsored';
    MainDatasetTransactionDate.SetParentComponent(MainDataset);
    MainDatasetTransactionDate.Name := 'MainDatasetTransactionDate';
    MainDatasetTransactionDate.FieldName := 'TransactionDate';
    MainDatasetTransactionDate.DisplayFormat := 'DD/MM/YYYY';
    MainDatasetImportId.SetParentComponent(MainDataset);
    MainDatasetImportId.Name := 'MainDatasetImportId';
    MainDatasetImportId.FieldName := 'ImportId';
    MainDatasetClaimId.SetParentComponent(MainDataset);
    MainDatasetClaimId.Name := 'MainDatasetClaimId';
    MainDatasetClaimId.FieldName := 'ClaimId';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.FieldName := 'Amount';
    MainDatasetDonorId.SetParentComponent(MainDataset);
    MainDatasetDonorId.Name := 'MainDatasetDonorId';
    MainDatasetDonorId.FieldName := 'DonorId';
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 9;
    MainDatasetClaimDate.SetParentComponent(MainDataset);
    MainDatasetClaimDate.Name := 'MainDatasetClaimDate';
    MainDatasetClaimDate.FieldName := 'ClaimDate';
    MainDatasetTaxYear.SetParentComponent(MainDataset);
    MainDatasetTaxYear.Name := 'MainDatasetTaxYear';
    MainDatasetTaxYear.FieldName := 'TaxYear';
    MainDatasetClaimRef.SetParentComponent(MainDataset);
    MainDatasetClaimRef.Name := 'MainDatasetClaimRef';
    MainDatasetClaimRef.FieldName := 'ClaimRef';
    MainDatasetClaimRef.Size := 32;
    MainDatasetDonorPostCode.SetParentComponent(MainDataset);
    MainDatasetDonorPostCode.Name := 'MainDatasetDonorPostCode';
    MainDatasetDonorPostCode.FieldName := 'DonorPostCode';
    MainDatasetDonorPostCode.Size := 15;
    MainDatasetDonorName.SetParentComponent(MainDataset);
    MainDatasetDonorName.Name := 'MainDatasetDonorName';
    MainDatasetDonorName.FieldName := 'DonorName';
    MainDatasetDonorName.Size := 50;
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Left := 48;
    WebTimer1.Top := 432;
  finally
    DataTable.AfterLoadDFMValues;
    CaptionSpan.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetSponsored.AfterLoadDFMValues;
    MainDatasetTransactionDate.AfterLoadDFMValues;
    MainDatasetImportId.AfterLoadDFMValues;
    MainDatasetClaimId.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetDonorId.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetClaimDate.AfterLoadDFMValues;
    MainDatasetTaxYear.AfterLoadDFMValues;
    MainDatasetClaimRef.AfterLoadDFMValues;
    MainDatasetDonorPostCode.AfterLoadDFMValues;
    MainDatasetDonorName.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
  end;
end;

end.